@if (isMenuLinkBox) {
  @if (showMenuLinkPanel) {
    <div class="{{cardClasses}}"
      attr.id="{{panel.id + '_widget'}}"
      attr.data-automation-id="lm-{{panel.automationId}}-widget">
      <div class="card-header">
        <h2
          [ngStyle]="{'display': 'inline-block'}"
          attr.id="{{panel.id}}_widget_title"
          attr.data-automation-id="lm-{{panel.automationId}}-widget-title"
          ><lm-widget-title [title]="panel.title" [icon]="panel.icon" [iconUrl]="panel.iconUrl"></lm-widget-title></h2>
        </div>
        <div class="card-content no-scroll">
          @for (link of links; track link) {
            @if (link.visible) {
              <div class="link"
                attr.data-automation-id="lm-{{ link.menu.automationId }}-link"
                [ngClass]="[link.width === 'double' ? 'dual' : 'single']"
                tabindex="0"
                soho-tooltip [content]="link?.description ? link.description : undefined"
                (click)="onLinkClicked(link)">
                <div class="status">
                  @if (link.menu.image) {
                    <img class="avatar" src="{{link.menu.image}}" alt=""/>
                  } @else {
                    @if (link.menu.missingImageUrl) {
                      <img class="avatar" src="{{link.menu.missingImageUrl}}" alt=""/>
                    } @else {
                      <!-- Need to have the space for an empty image, or the layout is incorrect-->
                      <img class="avatar" alt=""/>
                    }
                  }
                </div>
                <div class="text">
                  <div class="title">
                    {{ link.title }}
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
  } @else {
    <div class="{{cardClasses}}"
      attr.id="{{panel.id + '_widget'}}"
      attr.data-automation-id="lm-{{panel.automationId}}-widget"
      [ngClass]="[ panel.hideBorder ? 'no-shadow border-less' : '']"
      [class.background-image-attributes]="useBackgroundImage"
      [style.background-image]="backgroundImageUrl"
      >
      <div class="card-header" [class.menu-panel-header]="isMenuPanel && panel.icon">
        <h2 soho-widget-title
          [ngStyle]="{'display': 'inline-block'}"
          [ngClass]="{'hasOverviewClass': (hasOverviewNavigation && displayLinkAsText), 'widget-title': true }"
          attr.id="{{panel.id}}_widget_title"
          attr.data-automation-id="lm-{{panel.automationId}}-widget-title"
          ><lm-widget-title [title]="panel.title" [icon]="panel.icon" [iconUrl]="panel.iconUrl"></lm-widget-title></h2>
          @if (!drillAroundWindow) {
            <div class="panelNavigation">
              @if (hasOverviewNavigation && !displayLinkAsText) {
                <button
                  soho-button="icon"
                  icon="right-arrow"
                  soho-tooltip [content]="overNavigationLink"
                  (click)="onNavigationClick($event)"
                  attr.id="{{panel.id}}_overview_navigation"
                  attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
                ></button>
              }
              @if (hasOverviewNavigation && displayLinkAsText) {
                <a
                  [attr.tabindex]="isInAccessibilityMode ? 0 : null"
                  attr.aria-label="{{panel.title}} - {{overNavigationLink}}"
                  soho-hyperlink
                  class="lm-hyperlink"
                  (click)="onNavigationClick($event)"
                  (keydown.enter)="onNavigationClick($event)"
                  soho-tooltip [content]="overNavigationLink"
                  attr.id="{{panel.id}}_overview_navigation"
                  attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
                >{{overNavigationLink}}</a>
              }
            </div>
          }
        </div>
        @if (panel.formSpec && fromDataView && panel.type !== 'menuPanel') {
          <div class="card-content">
            <!-- I believe we dont' allow related OTO data in a form detail section/dashboard/etc. Not completely sure. -->
            @if (!panel.onCompositeForm) {
              <lm-form #LMFormComponent
                [formUrlInfo]="formUrlInfo"
                [formSpec]="panel.formSpec"
                [fromDataView]="fromDataView"
                [formOptions]="{isDashBoardContent: true}"
                [isInOverlay]="isFlyoutContent"
                (formRendered)="onFormRendered()"
                [ngStyle]="{'padding-top': '10px'}">
              </lm-form>
            }
            @if (panel.onCompositeForm && panel.type !== 'independentform') {
              <lm-form-layout #LMFormComponent
                [formSpec]="panel.formSpec"
                [layout]="panel.layout"
                [formOptions]="{isDashBoardContent: true}"
                [model]="model"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                (dataViewLoaded)="onFormRendered()"
                (fieldEvent)="onFieldEvent($event)"
                [ngStyle]="{'padding': '10px 0px 10px 10px'}">
              </lm-form-layout>
            }
            @if (panel.onCompositeForm && panel.type === 'independentform') {
              <lm-form #LMFormComponent
                [formUrlInfo]="formUrlInfo"
                [formSpec]="panel.formSpec"
                [fromDataView]="fromDataView"
                [formOptions]="{isDashBoardContent: true}"
                [isInOverlay]="isFlyoutContent"
                (formRendered)="onFormRendered()"
                [ngStyle]="{'padding': '10px 0px 0px 10px'}">
              </lm-form>
            }
          </div>
        }
        @if (panel.formSpec && panel.type === 'menuPanel') {
          <div class="card-content">
            <!-- todo: not sure formUrlInfo is even needed for form panels in a widget
            for a composite form that implements DashboardView.
            -->
            <lm-form #LMFormComponent
              [formUrlInfo]="formUrlInfo"
              [formSpec]="panel.formSpec"
              [initDataView]="initDataView"
              [formOptions]="{isDashBoardContent: true}"
              [isInOverlay]="isFlyoutContent"
              (formRendered)="onFormRendered()"
            ></lm-form>
          </div>
        }
      </div>
    }
